<template>
  <table>
    <tr>
      <th class="th">{{ name }}</th>
    </tr>
    <tr
      v-for="(elem, index) in data"
      @click="attribute === 'zip' ? '' : onSelect(elem, $event)"
      :key="index"
      :class="
        availableData.some((key) => key[attribute] === elem[attribute])
          ? 'available'
          : 'unavailable'
      "
    >
      <td @click="attribute=='zip'?nextTickInput($event):''"><input
          v-if="attribute === 'zip'"
          @change="nextTickInput($event)"
          name="marketAreaBox"
          type="checkbox"
          :id="'checkbox' + index"
          :value="elem[attribute]"
          v-model="checkedBoxes"
        />
      {{
        elem[attribute]
      }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "MarketAreaTabTable",
  data() {
    return {
      checkedBoxes: [],
    };
  },
  props: {
    onSelect: Function,
    data: Array,
    availableData: Array,
    name: String,
    attribute: String,
  },
  methods: {
    nextTickInput: function(event) {  
  
      this.$nextTick(() => {       
        this.onSelect(this.checkedBoxes.toString(), event);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  margin: 24px;
  overflow-y: scroll;
  min-width: 100px;
  min-height: 75px;
  max-height: 275px;
  display: block;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
table::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.available {
  color: #3c4858;
  font-size: 0.8375rem;
  cursor: pointer;
}
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.8375rem;
}
.th {
  text-align: left;
}
</style>
